var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "1200px",
            "max-height": "90vh",
            persistent: ""
          },
          model: {
            value: _vm.show,
            callback: function($$v) {
              _vm.show = $$v
            },
            expression: "show"
          }
        },
        [
          _c(
            "v-card",
            {
              staticStyle: {
                "max-height": "90vh",
                display: "flex",
                "flex-direction": "column"
              }
            },
            [
              _c(
                "v-card-title",
                { staticClass: "primary white--text" },
                [
                  _c("v-icon", { attrs: { left: "", color: "white" } }, [
                    _vm._v("mdi-account-plus")
                  ]),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.modoEdicao
                          ? ` Editar Login Social: ${_vm.loginSocial.nome}`
                          : "Criar Novo Login Social"
                      ) +
                      " "
                  ),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: { click: _vm.fecharModal }
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-text",
                {
                  staticClass: "pa-6",
                  staticStyle: { flex: "1", "overflow-y": "auto" }
                },
                [
                  _c("Loading", {
                    attrs: { active: _vm.loading, "is-full-page": false }
                  }),
                  _c(
                    "v-form",
                    {
                      ref: "formLoginSocial",
                      model: {
                        value: _vm.formValido,
                        callback: function($$v) {
                          _vm.formValido = $$v
                        },
                        expression: "formValido"
                      }
                    },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", md: "6" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Nome *",
                                  outlined: "",
                                  dense: "",
                                  rules: _vm.nomeRules,
                                  disabled: _vm.loading,
                                  "data-cy": "nome"
                                },
                                model: {
                                  value: _vm.dadosEdicao.nome,
                                  callback: function($$v) {
                                    _vm.$set(_vm.dadosEdicao, "nome", $$v)
                                  },
                                  expression: "dadosEdicao.nome"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", md: "6" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Email *",
                                  outlined: "",
                                  dense: "",
                                  type: "email",
                                  rules: _vm.emailRules,
                                  disabled: _vm.loading || _vm.modoEdicao,
                                  "data-cy": "email"
                                },
                                model: {
                                  value: _vm.dadosEdicao.email,
                                  callback: function($$v) {
                                    _vm.$set(_vm.dadosEdicao, "email", $$v)
                                  },
                                  expression: "dadosEdicao.email"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", md: "6" } },
                            [
                              _c("v-select", {
                                attrs: {
                                  items: _vm.perfilOptions,
                                  label: "Perfil *",
                                  outlined: "",
                                  dense: "",
                                  rules: _vm.perfilRules,
                                  disabled: _vm.loading,
                                  "data-cy": "perfil"
                                },
                                model: {
                                  value: _vm.dadosEdicao.perfil,
                                  callback: function($$v) {
                                    _vm.$set(_vm.dadosEdicao, "perfil", $$v)
                                  },
                                  expression: "dadosEdicao.perfil"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", md: "6" } },
                            [
                              _c(
                                "v-row",
                                { staticClass: "flex-column flex-md-row" },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "8" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: "Senha (Opcional)",
                                          outlined: "",
                                          dense: "",
                                          type: _vm.showPassword
                                            ? "text"
                                            : "password",
                                          "append-icon": _vm.showPassword
                                            ? "mdi-eye-off"
                                            : "mdi-eye",
                                          disabled: _vm.loading,
                                          "data-cy": "senha"
                                        },
                                        on: {
                                          "click:append": function($event) {
                                            _vm.showPassword = !_vm.showPassword
                                          }
                                        },
                                        model: {
                                          value: _vm.dadosEdicao.senha,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.dadosEdicao,
                                              "senha",
                                              $$v
                                            )
                                          },
                                          expression: "dadosEdicao.senha"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass: "d-flex justify-center",
                                      attrs: { cols: "12", md: "4" }
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            color: "primary",
                                            disabled: _vm.loading
                                          },
                                          on: { click: _vm.gerarSenha }
                                        },
                                        [_vm._v(" Gerar Senha ")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("v-divider", { staticClass: "my-4" }),
                              _c("h3", { staticClass: "mb-4" }, [
                                _vm._v(" Associação de Apresentantes ")
                              ]),
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "5" } },
                                    [
                                      _c(
                                        "v-card",
                                        {
                                          staticStyle: {
                                            height: "345px",
                                            display: "flex",
                                            "flex-direction": "column"
                                          },
                                          attrs: { outlined: "" }
                                        },
                                        [
                                          _c(
                                            "v-card-title",
                                            { staticClass: "text-h6 py-3" },
                                            [
                                              _vm._v(
                                                " Apresentantes Disponíveis "
                                              ),
                                              _c("v-spacer"),
                                              _c(
                                                "v-chip",
                                                {
                                                  attrs: {
                                                    small: "",
                                                    color: "secondary"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm
                                                        .apresentantesDisponiveisFiltrados
                                                        .length
                                                    )
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-card-text",
                                            { staticClass: "pa-0" },
                                            [
                                              _c("v-text-field", {
                                                staticClass: "ma-3 mt-0",
                                                attrs: {
                                                  label:
                                                    "Buscar por sigla ou nome",
                                                  outlined: "",
                                                  dense: "",
                                                  "hide-details": "",
                                                  "prepend-inner-icon":
                                                    "mdi-magnify"
                                                },
                                                model: {
                                                  value: _vm.buscarDisponivel,
                                                  callback: function($$v) {
                                                    _vm.buscarDisponivel = $$v
                                                  },
                                                  expression: "buscarDisponivel"
                                                }
                                              }),
                                              _c(
                                                "v-list",
                                                {
                                                  staticClass:
                                                    "apresentantes-list",
                                                  staticStyle: {
                                                    flex: "1",
                                                    "overflow-y": "auto"
                                                  },
                                                  attrs: { dense: "" }
                                                },
                                                [
                                                  _vm
                                                    .apresentantesDisponiveisFiltrados
                                                    .length === 0
                                                    ? _c(
                                                        "v-list-item",
                                                        {
                                                          attrs: {
                                                            disabled: ""
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-list-item-content",
                                                            [
                                                              _c(
                                                                "v-list-item-title",
                                                                {
                                                                  staticClass:
                                                                    "text-center grey--text"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        _vm
                                                                          .apresentantesDisponiveis
                                                                          .length ===
                                                                          0
                                                                          ? "Carregando apresentantes..."
                                                                          : "Todos os apresentantes já foram selecionados"
                                                                      ) +
                                                                      " "
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  _vm._l(
                                                    _vm.apresentantesDisponiveisFiltrados,
                                                    function(apresentante) {
                                                      return _c(
                                                        "v-list-item",
                                                        {
                                                          key:
                                                            apresentante.sigla,
                                                          class: {
                                                            "v-list-item--active": _vm.apresentantesSelecionadosTemp.includes(
                                                              apresentante.sigla
                                                            )
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.selecionarApresentante(
                                                                apresentante
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c(
                                                            "v-list-item-content",
                                                            [
                                                              _c(
                                                                "v-list-item-title",
                                                                [
                                                                  _vm._v(
                                                                    " " +
                                                                      _vm._s(
                                                                        apresentante.sigla
                                                                      ) +
                                                                      " - " +
                                                                      _vm._s(
                                                                        apresentante.nome
                                                                      ) +
                                                                      " "
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    }
                                                  )
                                                ],
                                                2
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      staticClass:
                                        "d-flex flex-column justify-center align-center",
                                      attrs: { cols: "12", md: "2" }
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "mb-2",
                                          attrs: {
                                            color: "primary",
                                            disabled:
                                              _vm.apresentantesSelecionadosTemp
                                                .length === 0
                                          },
                                          on: {
                                            click: _vm.adicionarSelecionados
                                          }
                                        },
                                        [
                                          _c("v-icon", [
                                            _vm._v("mdi-arrow-right")
                                          ])
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            color: "secondary",
                                            disabled:
                                              _vm.apresentantesParaRemover
                                                .length === 0
                                          },
                                          on: { click: _vm.removerSelecionados }
                                        },
                                        [
                                          _c("v-icon", [
                                            _vm._v("mdi-arrow-left")
                                          ])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "5" } },
                                    [
                                      _c(
                                        "v-card",
                                        {
                                          staticStyle: {
                                            height: "345px",
                                            display: "flex",
                                            "flex-direction": "column"
                                          },
                                          attrs: { outlined: "" }
                                        },
                                        [
                                          _c(
                                            "v-card-title",
                                            { staticClass: "text-h6 py-3" },
                                            [
                                              _vm._v(
                                                " Apresentantes Selecionados "
                                              ),
                                              _c("v-spacer"),
                                              _c(
                                                "v-chip",
                                                {
                                                  attrs: {
                                                    small: "",
                                                    color: "primary"
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.dadosEdicao
                                                        .apresentantesSelecionados
                                                        .length
                                                    )
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-card-text",
                                            {
                                              staticClass: "pa-0",
                                              staticStyle: {
                                                flex: "1",
                                                display: "flex",
                                                "flex-direction": "column"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "ma-3 mb-0",
                                                  staticStyle: {
                                                    height: "40px",
                                                    display: "flex",
                                                    "align-items": "center"
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-caption grey--text"
                                                    },
                                                    [
                                                      _vm._v(
                                                        " Clique para selecionar apresentantes para remoção "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm.dadosEdicao
                                                .apresentantesSelecionados
                                                .length === 0
                                                ? _c(
                                                    "v-alert",
                                                    {
                                                      staticClass: "ma-3 mt-0",
                                                      attrs: {
                                                        type: "warning",
                                                        dense: "",
                                                        text: ""
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        " Pelo menos um apresentante deve ser selecionado "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _c(
                                                "v-list",
                                                {
                                                  staticClass:
                                                    "apresentantes-list",
                                                  staticStyle: {
                                                    flex: "1",
                                                    "overflow-y": "auto"
                                                  },
                                                  attrs: { dense: "" }
                                                },
                                                _vm._l(
                                                  _vm.dadosEdicao
                                                    .apresentantesSelecionados,
                                                  function(sigla) {
                                                    return _c(
                                                      "v-list-item",
                                                      {
                                                        key: sigla,
                                                        class: {
                                                          "v-list-item--active": _vm.apresentantesParaRemover.includes(
                                                            sigla
                                                          )
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.selecionarParaRemover(
                                                              sigla
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "v-list-item-content",
                                                          [
                                                            _c(
                                                              "v-list-item-title",
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      sigla
                                                                    ) +
                                                                    " - " +
                                                                    _vm._s(
                                                                      _vm.getNomeBySigla(
                                                                        sigla
                                                                      )
                                                                    ) +
                                                                    " "
                                                                )
                                                              ]
                                                            )
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  }
                                                ),
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-actions",
                { staticClass: "pa-6" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "success",
                        loading: _vm.loading,
                        disabled:
                          !_vm.formValido ||
                          _vm.dadosEdicao.apresentantesSelecionados.length === 0
                      },
                      on: { click: _vm.salvarLoginSocial }
                    },
                    [
                      _c("v-icon", { attrs: { left: "" } }, [
                        _vm._v("mdi-content-save")
                      ]),
                      _vm._v(
                        " " +
                          _vm._s(_vm.modoEdicao ? "Atualizar" : "Salvar") +
                          " "
                      )
                    ],
                    1
                  ),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      staticStyle: {
                        "background-color": "#e74c3c",
                        color: "white"
                      },
                      attrs: { loading: _vm.loading },
                      on: {
                        click: function($event) {
                          return _vm.salvarLoginSocial("desativar")
                        }
                      }
                    },
                    [
                      _c("v-icon", { attrs: { left: "", color: "white" } }, [
                        _vm._v("mdi-account-remove")
                      ]),
                      _vm._v(" Desativar Login Social ")
                    ],
                    1
                  ),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "grey", text: "", disabled: _vm.loading },
                      on: { click: _vm.fecharModal }
                    },
                    [_vm._v(" Cancelar ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500" },
          model: {
            value: _vm.dialogConfirmacaoRemocao,
            callback: function($$v) {
              _vm.dialogConfirmacaoRemocao = $$v
            },
            expression: "dialogConfirmacaoRemocao"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "headline" }, [
                _vm._v(" Confirmar Remocao ")
              ]),
              _c("v-card-text", [
                _vm._v(
                  " Remover este apresentante desabilitará o acesso via login social. Continuar? "
                )
              ]),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "grey", text: "" },
                      on: {
                        click: function($event) {
                          _vm.dialogConfirmacaoRemocao = false
                        }
                      }
                    },
                    [_vm._v(" Cancelar ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "red" },
                      on: { click: _vm.confirmarRemocaoApresentante }
                    },
                    [_vm._v(" Remover ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "500" },
          model: {
            value: _vm.dialogConfirmacaoDesativacao,
            callback: function($$v) {
              _vm.dialogConfirmacaoDesativacao = $$v
            },
            expression: "dialogConfirmacaoDesativacao"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "headline red--text" },
                [
                  _c("v-icon", { attrs: { left: "", color: "red" } }, [
                    _vm._v("mdi-alert")
                  ]),
                  _vm._v(" Confirmar Desativação ")
                ],
                1
              ),
              _c(
                "v-card-text",
                [
                  _c("p", { staticClass: "mb-4" }, [
                    _vm._v(
                      " Esta ação irá desativar permanentemente o login social e remover todos os apresentantes associados. "
                    )
                  ]),
                  _c("p", { staticClass: "mb-4 font-weight-bold" }, [
                    _vm._v(
                      ' Para confirmar, digite "desativar" no campo abaixo: '
                    )
                  ]),
                  _c("v-text-field", {
                    attrs: {
                      label: "Digite 'desativar' para confirmar",
                      outlined: "",
                      dense: "",
                      error:
                        _vm.textoConfirmacao.length > 0 &&
                        _vm.textoConfirmacao !== "desativar",
                      "error-messages":
                        _vm.textoConfirmacao.length > 0 &&
                        _vm.textoConfirmacao !== "desativar"
                          ? "Texto não confere"
                          : ""
                    },
                    model: {
                      value: _vm.textoConfirmacao,
                      callback: function($$v) {
                        _vm.textoConfirmacao = $$v
                      },
                      expression: "textoConfirmacao"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "grey", text: "" },
                      on: { click: _vm.fecharModalDesativacao }
                    },
                    [_vm._v(" Cancelar ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "red",
                        disabled: _vm.textoConfirmacao !== "desativar",
                        loading: _vm.loading
                      },
                      on: { click: _vm.confirmarDesativacao }
                    },
                    [
                      _c("v-icon", { attrs: { left: "" } }, [
                        _vm._v("mdi-account-remove")
                      ]),
                      _vm._v(" Confirmar Desativação ")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }